<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold" v-html="title" />
    <div class="col-12 col-md-8 col-xl-9">
      <button type="button"
        v-for="(item, index) in items"
        :key="index"
        :class="['btn btn-sm btn-outline-filter', filterUiState('soundReductionIndex', item.value)]"
        v-on:click="selectValue(item.value)">{{ item.title }}</button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionSoundReductionIndex',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'R<sub>W</sub> (C;C<sub>tr</sub>) [dB]',
      items: [
        { title: '≥ 44', value: 44 },
        { title: '≥ 58', value: 58 },
        { title: '≥ 59', value: 59 },
        { title: '≥ 61', value: 61 },
        { title: '≥ 62', value: 62 },
        { title: '≥ 63', value: 63 },
        { title: '≥ 64', value: 64 },
        { title: '≥ 65', value: 65 },
        { title: '≥ 66', value: 66 },
        { title: '≥ 67', value: 67 },
        { title: '≥ 68', value: 68 },
        { title: '≥ 69', value: 69 },
        { title: '≥ 70', value: 70 },
        { title: '≥ 73', value: 73 },
        { title: '≥ 75', value: 75 },
        { title: '≥ 77', value: 77 },
        { title: '≥ 78', value: 78 },
        { title: '≥ 80', value: 80 },
        { title: '≥ 81', value: 81 },
        { title: '≥ 83', value: 83 },
        { title: '≥ 84', value: 84 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      const result = this.items.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('soundReductionIndex', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title.split('<sub>').join('').split('</sub>').join('') + ' ' + title,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value
      })

      this.$store.dispatch('filter/setValue', {
        name: 'soundReductionIndex',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
